<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <span>
    <v-layout class="align-center entry_filters_left_justified" row>
      <v-flex class="align-center" lg7 md6 sm9 xs7>
        <span>{{ heading }}</span>
      </v-flex>
      <v-flex v-if="!all_open" class="align-start justify-start mr-1" lg1>
        <v-btn class="white mr-4 ml-5" text x-small @click="show = !show">
          <v-icon v-if="!show" dark> mdi-chevron-down </v-icon>
          <v-icon v-if="show" dark> mdi-chevron-up </v-icon></v-btn
        >
      </v-flex>
      <v-flex v-if="result">
        <span v-html="result"></span>
<!--        work here-->
      </v-flex>
      <v-flex>
        <v-img :src="image" class="ma-1" max-height="100" max-width="45"></v-img>
      </v-flex>
    </v-layout>

    <v-layout v-if="show" class="justify-space-between mt-2 mb-2 mr-2" row>
      <v-flex class="blue-grey white--text pa-2" lg12 md7 sm11 xs11>
        <span class="pa-3 transition-ease-in-out">{{ explanation }} </span>
      </v-flex>
    </v-layout>
  </span>
</template>

<script>
  export default {
    name: 'result_hover',
    props: ['heading', 'explanation', 'result', 'image', 'all_open'],
    watch: {
      all_open: function () {
        this.show = this.all_open;
      },
    },

    data: () => {
      return {
        show: false,
      };
    },
  };
</script>

<style scoped>
  .pic_left {
  }
</style>
